<template>
  <c-step
    stepperGrpCd="RAM_4M_STEP_CD"
    :currentStepCd="popupParam.ramStepCd"
    :param="param"
    v-model="ramStepCd"
    @stepBystep="stepBystep"
    @keySetting="keySetting"
    @research="research"
    @stepClick="stepClick"
    @closePopup="closePopup">
  </c-step>
</template>

<script>
import { uid } from 'quasar'
export default {
  name: 'fm-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: '',
        ramStepCd: '',
        vendorFlag: false,
      }),
    },
  },
  data() {
    return {
      editable: true,
      ramStepCd: '',
      searchRiskReduce: {
        flag: '',
        isSearch: false,
      },
      searchScenario: {
        flag: '',
        isSearch: false,
      },
      planUpdateBtnData: {
        title: '계획',
        flag: false,
        research: '',
        planResearch: '',
      },
    };
  },
  watch: {
    'popupParam.ramStepCd'() {
      this.setStep();
    },
  },
  computed: {
    param() {
      return {
        ramRiskAssessmentPlanId: this.popupParam.ramRiskAssessmentPlanId,
        ramStepCd: this.popupParam.ramStepCd,
        vendorFlag: this.popupParam.vendorFlag,
        searchRiskReduce: {
          flag: this.searchRiskReduce.flag,
          isSearch: this.searchRiskReduce.isSearch,
        },
        searchScenario: {
          flag: this.searchScenario.flag,
          isSearch: this.searchScenario.isSearch,
        },
        planUpdateBtnData: this.planUpdateBtnData,
        /**
         * 안전보건팀 권한자 삭제 버튼 활성화 기준
         *  - 감소대책 계획 및 실행 단계 또는 평가완료 인 경우
         *  - 현업이 작성한 경우
         */
        safHeaAuthDeleteEditable: !this.popupParam.vendorFlag
          && (this.popupParam.ramStepCd === 'R4RS00010' 
            || this.popupParam.ramStepCd === 'R4RS00015')
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      // url setting
      // code setting
      // list setting
      this.setStep();
    },
    setStep() {
      /**
       * R4RS00005 R4RS00010 단계는 같은 단계로 취급 
       * R4RS00005으로 데이터가 저장되지 않고 R4RS00010으로 저장
       * R4RS00010인 경우 팝업에서는 '평가실행'으로 표시되도록 R4RS00005으로 셋팅
       *  */ 
      if (this.popupParam.ramStepCd === 'R4RS00010') {
        this.ramStepCd = 'R4RS00005'
      } else {
        this.ramStepCd = this.$_.clone(this.popupParam.ramStepCd);
      }
    },
    stepBystep(stepCd) {
      this.popupParam.ramStepCd = stepCd
    },
    keySetting(key) {
      this.popupParam.ramRiskAssessmentPlanId = key
    },
    research(data) {
      if (data.place === 'scenario') {
        this.searchRiskReduce.isSearch = true;
      } else {
        this.searchScenario.isSearch = true;
      }
    },
    stepClick(step) {
      if (step === 'R4RS00010' && this.searchRiskReduce.isSearch) {
        this.searchRiskReduce.flag = uid();
        this.searchRiskReduce.isSearch = false;
      } else if (step === 'R4RS00005' && this.searchScenario.isSearch) {
        this.searchScenario.flag = uid();
        this.searchScenario.isSearch = false;
      }
    },
    closePopup() {
      this.$emit('closePopup')
    }
  }
};
</script>
